import {
  BrowserRouter as Router,
  Route,
  Routes,
  BrowserRouter,
} from 'react-router-dom';
import TitleBox from './components/TitleBox';

import MainLayout from './layouts/MainLayout';

import SigninPage from './components/SigninPage';
import SignoutPage from './components/SignoutPage';
import MainPage from './components/MainPage';
import { Provider } from './store/provider';
import Cockpit from './views/Cockpit';
import Logs from './views/Logs';
import React from 'react';
import Insights from './views/Insights';
import Selection from './views/Selections';
import AllMyFlights from './views/AllMyFlights';
import Trends from './views/Trends';
import Grid from './views/Grid';
import ColumnDnd from './views/components/ColumnsDnd';
import SavedReports from "./views/SavedReports";

const App: React.FC = () => {

  return (
    <Provider>
      <Router>
        <MainLayout>
          <Routes>
            <Route path="signin" element={<SigninPage />} />
            <Route path="signout" element={<SignoutPage />} />
            <Route path="cockpit" element={<Cockpit />} />
            <Route path="logs" element={<Logs />} />
            <Route path="insights" element={<Insights />} />
            <Route path="selection" element={<Selection />} />
            <Route path="allmyflights" element={<AllMyFlights/>} />
            <Route path="trends" element={<Trends />} />
            <Route path="saved" element={<SavedReports />} />
            <Route path="flightsnapshot" element={<Grid Tab='All My Flights' Section='Screenshot' ReportName='Flight'/>} />
            <Route path="airportsnapshot" element={<Grid Tab='All My Flights' Section='Screenshot' ReportName='Airport'/>} />
            <Route path="citysnapshot" element={<Grid Tab='All My Flights' Section='Screenshot' ReportName='DestCity'/>} />
            <Route path="countrysnapshot" element={<Grid Tab='All My Flights' Section='Screenshot' ReportName='DestCountry'/>} />
            <Route path="grid" element={<Grid/>} />
          </Routes>
        </MainLayout>
      </Router>
    </Provider>
  );
};

export default App;
